export default __webpack_public_path__ + "static/media/desc-sub-banner-1.3816e76b.svg";